/* External dependencies */
import { StyleReset, ThemeProvider } from 'atomize';
import { useI18next } from 'gatsby-plugin-react-i18next';
import React from 'react';
import { Helmet } from 'react-helmet';

/* Local dependencies */
import './style.scss';

export default function WebLayout({ children }) {
  const theme = {
    colors: {
      text_color: 'rgba(107,114,128)',
      text_color_articles_description: '#637492',
      white: '#fff',
      black: '#222b45',
      text_color_for_teaser: '#222B45',
      btn_success_bg: '#43BF43',
      gray: '#EDF1F7',
      gray_bg_hover: '#D5DEEC',
      grayTextInCard: '#8F9BB3',
      grayTextInCardSmall: 'rgba(143, 155, 179, 0.5)',
      gray_mobile_line: 'rgba(34, 43, 69, 0.2)',
      basic_border_color: '#EDF1F7',
      btn_primary_bg: '#6574CF',
      btn_gray_bg: '#454A55',
      btn_hover_border_white: '#6574CF',
      btn_hover_border_primary: '#5464C9',
      bg_article_card: '#6574CF1A',
      btn_outlined_bg: 'transparent',
      btn_default_bg: '#EFEFEF',
      btn_hover_bg_primary: '#5464C9',
      btn_danger_bg: '#FF3D71',
      btn_hover_bg_danger: '#eb2257',
      bg_download_app: '#F3F6FA',
      bg_sky_color: '#E5E5E5',
      bg_tag: 'rgba(73, 91, 199, 0.12)',
      bg_dropdown: '#F3F6FA',
      primary: '#6574CF',
      label_color_purple: '#6574CF',
      label_color_green: '#218380',
      label_color_blue: '#3590F3',
      label_color_turquoise: '#0ACDFF',
      label_color_red: '#FD6F96',
      outlined: '#6574CF',
      table_cell_text_color: '#222B45',
      table_cell_background: '#E4E9F2',
      main_bg_color: '#F3F6FA',
      bg_color_banner: '#222B45',
      warning_color: '#ffcc00',
      input_border_color: '#E4E9F2',
      blocked_text_color: '#FF3B3B',
      approved_text_color: '#34BB6A',
      in_review_bg: '#D0D4F0',
      in_review_text_color: '#4556C4',
      incomplate_text_color: '#F5AB00',
      bg_black: '#0D1010',
      text_gray: '#0d101080',
      bg_approve: '#00D68F',
      bg_approve_hover: '#00be7f',
      success: '#43BF43',
    },
    fontFamily: {
      primary: 'Inter, sans-serif',
      secondary: 'Quicksand, sans-serif',
    },
    grid: {
      gutterWidth: '2rem',
    },
    rounded: {
      tenPixel: '10px',
      twentyFour: '24px',
      twenty: '20px',
      circle: '50%',
    },
    textSize: {
      size: {
        xs: '10px',
        tiny: '12px',
        small: '13px',
        body: '16px',
        smallSize1: '14px',
        smallSize2: '18px',
        display1: '20px',
        display2: '24px',
        medium: '22px',
        display: '26px',
        heading: '28px',
        errorTitle: '32px',
        subtitle: '36px',
        downloadAppTitle: '40px',
        title: '48px',
        bigTitle: '64px',
      },
      height: {
        xs: '12px',
        tiny: '16px',
        small: '16px',
        smallSize1: '22px',
        body: '24px',
        smallSize2: '26px',
        display1: '28px',
        display2: '32px',
        display: '32px',
        medium: '30px',
        heading: '34px',
        errorTitle: '39px',
        subtitle: '42px',
        downloadAppTitle: '48px',
        title: '58px',
        bigTitle: '104%',
      },
    },
    shadows: {
      'header-shadow': 'rgba(0, 0, 0, 0.15) 0px 1px 2px 0px',
    },
  };
  const { t, i18n } = useI18next();
  const title = t('siteMetaDataTitle');
  const currentLanguage = i18n.language;

  return (
    <ThemeProvider theme={theme}>
      <Helmet
        htmlAttributes={{
          lang: currentLanguage,
        }}
        title={title}
      >
        <meta charSet="utf-8" />
      </Helmet>
      <StyleReset />
      {children}
    </ThemeProvider>
  );
}
